var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistoryB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.334 3.33594H25V1.33594C25 0.782938 24.553 0.335938 24 0.335938C23.447 0.335938 23 0.782938 23 1.33594V3.33594H17V1.33594C17 0.782938 16.552 0.335938 16 0.335938C15.448 0.335938 15 0.782938 15 1.33594V3.33594H9V1.33594C9 0.782938 8.552 0.335938 8 0.335938C7.448 0.335938 7 0.782938 7 1.33594V3.33594H2.667C1.194 3.33594 0 4.52894 0 6.00194V29.6689C0 31.1419 1.194 32.3359 2.667 32.3359H29.334C30.807 32.3359 32 31.1419 32 29.6689V6.00194C32 4.52894 30.807 3.33594 29.334 3.33594ZM30 29.6689C30 30.0369 29.701 30.3359 29.334 30.3359H2.667C2.299 30.3359 2 30.0369 2 29.6689V6.00194C2 5.63494 2.299 5.33594 2.667 5.33594H7V7.33594C7 7.88894 7.448 8.33594 8 8.33594C8.552 8.33594 9 7.88894 9 7.33594V5.33594H15V7.33594C15 7.88894 15.448 8.33594 16 8.33594C16.552 8.33594 17 7.88894 17 7.33594V5.33594H23V7.33594C23 7.88894 23.447 8.33594 24 8.33594C24.553 8.33594 25 7.88894 25 7.33594V5.33594H29.334C29.701 5.33594 30 5.63494 30 6.00194V29.6689Z",
    fill: "#47127D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.3359H7V15.3359H11V12.3359Z",
    fill: "#47127D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.3359H7V20.3359H11V17.3359Z",
    fill: "#47127D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22.3359H7V25.3359H11V22.3359Z",
    fill: "#47127D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22.3359H14V25.3359H18V22.3359Z",
    fill: "#47127D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.3359H14V20.3359H18V17.3359Z",
    fill: "#47127D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.3359H14V15.3359H18V12.3359Z",
    fill: "#47127D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22.3359H21V25.3359H25V22.3359Z",
    fill: "#47127D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17.3359H21V20.3359H25V17.3359Z",
    fill: "#47127D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.3359H21V15.3359H25V12.3359Z",
    fill: "#47127D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryB);
export default __webpack_public_path__ + "static/media/History_B.7661bda28e44ee424e54740a16218c41.svg";
export { ForwardRef as ReactComponent };